<p class="quote-card__footer-text" *ngIf="!isAgentSubmittedApp">
  This proposal assumes
  <span>{{ insuredFullName }}</span>
  is a
  <span class="quote-card__person-info">{{ gender }}</span>
  born on
  <span class="quote-card__person-info">{{ dob }}</span>
  who
  <span class="quote-card__person-info">{{ isSmoker ? 'does' : 'does not' }} smoke</span>
  <ng-container *ngIf="alir1035TransferAmount; else showRateClass">
    <span>and has</span>
    <span class="quote-card__person-info">
      a transfer of {{ alir1035TransferAmount | casCurrency: 0 }} from another policy
      <span *ngIf="!hasExchange1035TowardsPremium">.</span>
      <span *ngIf="hasExchange1035TowardsPremium">
        <span>, which will</span>
        <span class="quote-card__person-info">apply to the initial premium.</span>
      </span>
    </span>
    <br />
  </ng-container>
  <ng-template #showRateClass>.</ng-template>
  <span *ngIf="cirAmount">
    It includes a
    <span class="quote-card__person-info">Chronic Illness Rider</span>
    with a {{ cirAmount | casCurrency: 0 }} benefit that you can access if the insured becomes chronically ill.
    <br />
  </span>
  <span>Your final price may vary after you apply.</span>
  <span *ngIf="termHasECP">An Extended Conversion Period is included (for the Convertible Term policy).</span>

  <ng-container *ngIf="hasWholeLifePolicy">
    For a detailed pdf of your Whole Life {{ wholeTerm }} Proposal:
    <a
      *ngIf="!displaySupplemental"
      href="javascript:void(0)"
      class="quote-card__view-basic-illustration"
      id="vst-get-basic-illustration"
      (click)="getBasicIllustrationPdf(false)"
    >
      <span>{{ 'View ' + (isJointApp ? 'Whole Life ' : '') + 'Basic Illustration' }}</span>
      <img
        class="quote-card__open-link-icon-right"
        src="/img/components/transition-card/illustration.svg"
        alt="View Basic Illustration"
      />
    </a>
    <a
      *ngIf="displaySupplemental"
      href="javascript:void(0)"
      class="quote-card__view-basic-illustration"
      id="vst-get-basic-illustration"
      (click)="getBasicIllustrationPdf(true)"
    >
      <span>View Supplemental Illustration</span>
      <img
        class="quote-card__open-link-icon-right"
        src="/img/components/transition-card/illustration.svg"
        alt="View Supplemental Illustration"
      />
    </a>
  </ng-container>
  <br />
  <span *ngIf="isART">* The premium of {{ artDescription }} increases annually.</span>
</p>
<p class="quote-card__footer-text" *ngIf="isAgentSubmittedApp">
  <span *ngIf="!hasRegistered">Create your Coverpath account to review and accept offer.</span>
  <span *ngIf="hasRegistered">Log in to your Coverpath account to review and accept offer.</span>
</p>
